<template>
  <transition name="fade">
    <div v-if="!loaded" id="loading-root">
      <div class="images">
        <img
          v-for="index in 6"
          class="loading-parts"
          :class="loadingPartsClass(index)"
          :key="index"
          :src="`/images/loading/loading-${index}.svg`"
        />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    loaded: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      count: 0
    }
  },
  mounted() {
    setInterval(() => {
      this.count = (this.count + 1) % 8
    }, 300)
  },
  methods: {
    loadingPartsClass(index) {
      return {
        [`loading-parts-${index}`]: true,
        fadeIn: this.count >= index && this.count !== 7,
        fadeOut: this.count === 7
      }
    }
  }
}
</script>

<style lang="sass" scoped>
$duration: 500ms

#loading-root
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  background: fixed
  display: flex
  justify-content: center
  align-items: center
  transition: opacity 1s
  background-color: white
  &.fade-leave-active
    opacity: 0

.loading-parts
  width: 22px
  height: 22px
  position: absolute
  opacity: 0

.loading-parts-1
  left: 24px
  bottom: 0

.loading-parts-2
  left: 24px
  bottom: 24px

.loading-parts-3
  width: 31px
  height: 31px
  right: 0
  top: 0

.loading-parts-4
  left: 0
  bottom: 24px

.loading-parts-5
  left: 48px
  bottom: 24px

.loading-parts-6
  left: 72px
  bottom: 24px

.images
  position: relative
  width: 100px
  height: 80px

.fadeIn
  animation-name: fadeIn
  animation-duration: $duration
  filter: blur(0)
  opacity: 1

.fadeOut
  animation-name: fadeOut
  animation-duration: $duration

@keyframes fadeIn
  from
    filter: blur(3px)
    opacity: 0
  to
    filter: blur(0)
    opacity: 1

@keyframes fadeOut
  from
    filter: blur(0)
    opacity: 1
  to
    filter: blur(3px)
    opacity: 0
</style>
